import React, { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "universal-cookie";
import DequipoOdontologiaEspecializada from "../../EliminaEquipos/DequipoOdontologiaEspecializada";
import CreaEquipoOdontologiaEspecializada from "./CreaEquipos/CreaOdontologiaEspecializada";

function EquipoOdontologiaEspecializada({ idSolicitud }) {
  const cookies = new Cookies();
  const [list, setList] = useState([]);

  const obtenerDatos = () => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerEquipoOdontologiaEspecialiazadaPorSolicitudId?SolicitudId=" +
        idSolicitud,
    })
      .then((response) => setList(response.data))
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    obtenerDatos();
  }, []);

  const url = window.location.href;
  const partesURL = url.split("/");
  const nombreRuta = partesURL[partesURL.indexOf("#") + 1];

  return (
    <div className="container">
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="m-0 font-weight-bold text-primary">
            Equipo primario de mejoramiento de Odontología Especializada
          </h6>
        </div>

        {cookies.get("tipo_Usuario") == 2 &&
          nombreRuta === "ProcesoAutoevaluacion" && (
            <CreaEquipoOdontologiaEspecializada
              idSolicitud={idSolicitud}
              onSuccess={obtenerDatos}
            />
          )}
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-bordered" width="100%">
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Nombre</th>
                  <th>Servicio</th>
                  <th>Cargo</th>
                  {nombreRuta === "ProcesoAutoevaluacion" && <th>Acciones</th>}
                </tr>
              </thead>
              <tbody>
                {list.map((item) => (
                  <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{item.nombre}</td>
                    <td>{item.servicio}</td>
                    <td>{item.cargo}</td>

                    {nombreRuta === "ProcesoAutoevaluacion" && (
                      <td>
                        <DequipoOdontologiaEspecializada
                          id={item.id}
                          onSuccess={obtenerDatos}
                        />
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EquipoOdontologiaEspecializada;
